import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, switchMap, startWith, Subject } from 'rxjs';
import { AnoCusto, MesCusto } from '../model/relatorio-custo.models';

@Injectable({ providedIn: 'root' })
export class RelatorioCustoService {
  private readonly http = inject(HttpClient);
  private readonly base = '/relatorio-custo';

  private readonly refreshAnos$ = new Subject<void>();

  readonly anos$ = this.refreshAnos$.pipe(
    startWith(void 0),
    switchMap(() => this.http.get<number[]>(`${this.base}/anos-disponiveis`)),
    shareReplay(1)
  );

  getAnosDisponiveis$(): Observable<number[]> {
    return this.anos$;
  }

  refreshAnos(): void {
    this.refreshAnos$.next();
  }

  getAno$(ano: number): Observable<AnoCusto> {
    return this.http.get<AnoCusto>(`${this.base}/ano/${ano}`);
  }

  getMes$(ano: number, mes: number): Observable<MesCusto> {
    return this.http.get<MesCusto>(`${this.base}/ano/${ano}/mes/${mes}`);
  }
}
